import LinkButton from '../../../components/link-button/link-button'
import config from '../../../config'
import { getDateTime } from '../../../helpers/utils'
import translate from '../../../i18n'
import {
  getPlanSubscriptionAutoRenewStatusLabel,
  getPlanSubscriptionStatusLabel,
} from '../../../pages/plan-subscriptions-container/constant'
import {
  IPlanSubscription,
  PlanSubscriptionRenewalMode,
} from '../../../pages/plan-subscriptions-container/share-type'
import { Button, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { TablePaginationConfig } from 'antd/lib/table/interface'

const { guavapassUrl } = config

const PlanSubscriptionsList = ({
  subscriptions,
  pagination,
  onPaginationChange,
}: {
  subscriptions: IPlanSubscription[]
  pagination: TablePaginationConfig
  onPaginationChange: (page: number, pageSize: number) => void
}) => {
  const columns: ColumnsType<IPlanSubscription> = [
    {
      title: 'ID',
      dataIndex: 'id',
      render: id => <LinkButton to={`/plan-subscriptions/${id}`}>{id}</LinkButton>,
    },
    {
      title: translate('planSubscriptions.user'),
      render: record => (
        <Button type="link" target="_blank" href={`${guavapassUrl}/admin/users/${record.userId}`}>
          {record.userName ? `User#${record.userId} ${record.userName}` : `User#${record.userId}`}
        </Button>
      ),
    },
    {
      title: translate('planSubscriptions.plan'),
      render: record => (
        <LinkButton to={`/plans/${record.planId}`}>
          {record.planExternalId ?? record.planId}
        </LinkButton>
      ),
    },
    {
      title: translate('planSubscriptions.status'),
      dataIndex: 'status',
      render: getPlanSubscriptionStatusLabel,
    },
    {
      title: translate('planSubscriptions.renewalMode'),
      dataIndex: 'renewalMode',
      render: (renewalMode: PlanSubscriptionRenewalMode) =>
        translate(`planSubscriptions.renewalMode.${renewalMode}`),
    },
    {
      title: translate('planSubscriptions.autoRenewStatus'),
      dataIndex: 'autoRenewStatus',
      render: getPlanSubscriptionAutoRenewStatusLabel,
    },
    {
      title: translate('planSubscriptions.currentPeriodEndsAt'),
      dataIndex: 'currentPeriodEndsAt',
      render: value => (value ? getDateTime(value) : '-'),
    },
    {
      title: translate('planSubscriptions.nextBillingAt'),
      dataIndex: 'nextBillingAt',
      render: value => (value ? getDateTime(value) : '-'),
    },
    {
      title: translate('tableActionColumn'),
      key: 'action',
      render: record => (
        <LinkButton to={`/plan-subscriptions/${record.id}`}>{translate('view')}</LinkButton>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={subscriptions}
      pagination={pagination}
      onChange={paginationConfig =>
        onPaginationChange(paginationConfig.current || 1, paginationConfig.pageSize || 10)
      }
      size="small"
    />
  )
}

export default PlanSubscriptionsList
